// extracted by mini-css-extract-plugin
module.exports = {"RelatedServicesContainer":"_3TS7-","RelatedServices":"Dti10","GridItem":"_1YwDz","Grid":"zBSoD"};